<div *nzModalTitle></div>
<div class="modal-content">
  <div class="header mb-4 sm:mb-4 lg:mb-6">
    <h2>{{ 'okeeyCash.validateUSAddress' | translate }}</h2>
  </div>
  <div class="text mb-6 sm:mb-6 lg:mb-8">
    <span>{{ 'okeeyCash.aValidUSAddressIsCrucial' | translate }}</span>
    <br />
    <br />
    <span>{{ 'okeeyCash.toAssistYouWithCorrect' | translate }}</span>
  </div>
  <div class="address-field mb-1 sm:mb-1 lg:mb-2">
    <korviu-input label="{{ 'okeeyCash.address' | translate }}" [control]="addressControl" #addresstext></korviu-input>
  </div>
</div>
<div *nzModalFooter>
  <div>
    <korviu-button color="tertiary" [disabled]="placeControl.invalid" (click)="onValidateAddressClick()">
      {{ 'okeeyCash.validateAddress' | translate }}
    </korviu-button>
  </div>
  @if (okeeyCashFormatFormIsVisible) {
    <div class="okeey-cash-format mt-8 sm:mt-8 lg:mt-10">
      <div class="okeey-cash-format-title mb-8">
        <span>{{ 'okeeyCash.okeeyCashFormat' | translate }}</span>
      </div>
      <div class="okeey-cash-format-body">
        <div class="okeey-cash-format-body-street-address">
          <div class="input-with-copy">
            <div class="input-label">
              <span>{{ 'okeeyCash.streetAddress' | translate }}</span>
            </div>
            <div class="input">
              <korviu-input [control]="street"></korviu-input>
              <copy-button (click)="copyText(street.value, 'okeeyCash.streetAddress')"></copy-button>
            </div>
          </div>
        </div>
        <div class="okeey-cash-format-body-apt-zip">
          <div class="input-with-copy">
            <div class="input-label">
              <span>{{ 'okeeyCash.aptSuite' | translate }}</span>
              <button
                [nzTooltipTitle]="aptTooltip"
                nzTooltipPlacement="bottomLeft"
                nz-button
                nz-tooltip
                appHideTooltipOnScroll
                nzType="text"
                class="ganarbols-list-item-tip"
              >
                <i nz-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path
                      d="M7.99974 1.83203C11.6822 1.83203 14.6674 4.81726 14.6674 8.49973C14.6674 12.1822 11.6822 15.1674 7.99974 15.1674C4.31726 15.1674 1.33203 12.1822 1.33203 8.49973C1.33203 4.81726 4.31726 1.83203 7.99974 1.83203ZM7.9972 7.3324C7.65527 7.33266 7.37367 7.5902 7.3354 7.9218L7.33094 7.99953L7.33334 11.6673L7.33787 11.745C7.37661 12.0765 7.6586 12.3337 8.00047 12.3335C8.34234 12.3333 8.62394 12.0757 8.66227 11.7441L8.66667 11.6664L8.66427 7.99866L8.65974 7.92093C8.621 7.5894 8.33907 7.3322 7.9972 7.3324ZM8 4.83272C7.5392 4.83272 7.16567 5.20626 7.16567 5.66706C7.16567 6.12786 7.5392 6.50141 8 6.50141C8.4608 6.50141 8.8344 6.12786 8.8344 5.66706C8.8344 5.20626 8.4608 4.83272 8 4.83272Z"
                      fill="#212121"
                    />
                  </svg>
                </i>
              </button>
            </div>
            <div class="input">
              <korviu-input [control]="apt"></korviu-input>
              <copy-button (click)="copyText(apt.value, 'okeeyCash.aptSuite')"></copy-button>
            </div>
          </div>
          <div class="input-with-copy">
            <div class="input-label">
              <span>{{ 'okeeyCash.ZIPcode' | translate }}</span>
            </div>
            <div class="input">
              <korviu-input [control]="zip"></korviu-input>
              <copy-button (click)="copyText(zip.value, 'okeeyCash.ZIPcode')"></copy-button>
            </div>
          </div>
        </div>
        <div class="okeey-cash-format-body-city">
          <div class="input-with-copy">
            <div class="input-label">
              <span>{{ 'okeeyCash.city' | translate }}</span>
            </div>
            <div class="input">
              <korviu-input [control]="city"></korviu-input>
              <copy-button (click)="copyText(city.value, 'okeeyCash.city')"></copy-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #aptTooltip>
  {{ 'okeeyCash.apartmentNumberValidationIsNotSupported' | translate }}
</ng-template>
